import { SearchX, ShieldAlert } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useRouteError } from "react-router"

import { LinkButton } from "@/components/shared/link-button"
import { messageOf } from "@/lib/problem"

function Shell({ icon, title, text, home }: { icon: React.ReactNode; title: string; text?: string; home: string }) {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-[70dvh] flex-col items-center justify-center gap-3 px-6 text-center">
      {icon}
      <h1 className="text-2xl font-bold">{title}</h1>
      {text && <p className="text-muted-foreground">{text}</p>}
      <LinkButton to={home} className="mt-2">
        {t("actions.home")}
      </LinkButton>
    </div>
  )
}

export function ForbiddenPage({ home = "/" }: { home?: string }) {
  const { t } = useTranslation()
  return (
    <Shell
      icon={<ShieldAlert className="size-12 text-danger" strokeWidth={1.5} />}
      title={t("errors.forbidden")}
      home={home}
    />
  )
}

export function NotFoundPage() {
  const { t } = useTranslation()
  return (
    <Shell
      icon={<SearchX className="size-12 text-muted-foreground" strokeWidth={1.5} />}
      title={t("errors.notFound")}
      home="/"
    />
  )
}

export function RouteErrorPage() {
  const { t } = useTranslation()
  const error = useRouteError()
  return (
    <Shell
      icon={<ShieldAlert className="size-12 text-danger" strokeWidth={1.5} />}
      title={t("errors.crashed")}
      text={messageOf(error)}
      home="/"
    />
  )
}
